import { SNACKBAR_CLOSE, SNACKBAR_OPEN } from "../action-types/snackbarAction";

export default function snackbarOpen(data: any) {
    return {
        type: SNACKBAR_OPEN,
        payload: data
    }
}

export function snackbarClose(data: any) {
    return {
        type: SNACKBAR_CLOSE,
        payload: data
    }
}